import { shuffleArray } from 'config/libraries';
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';

export const TagNavigation = () => {
    const [TagData, setTagData] = useState([]);
    
    const MenuProfile = 
    [
        {
            name: 'Visi Misi Layanan',
            link: '/static/visi-misi-layanan',
        },
        {
            name: 'Visi dan Misi',
            link: '/static/visi-dan-misi',
        },
        {
            name: 'Struktur Organisasi',
            link: '/static/struktur-organisasi',
        },
        {
            name: 'Bagan Organisasi',
            link: '/static/bagan-organisasi',
        },
        {
            name: 'Rekognisi',
            link: '/static/rekognisi',
        },
        {
            name: 'SK Penetapan Website',
            link: '/static/sk-penetapan-website',
        },
        {
            name: 'SK Tim pengelola Website',
            link: '/static/sk-tim-pengelola-website',
        },
        {
            name: 'SK Penunjukan Petugas Meja Pelayanan',
            link: '/static/sk-penunjukan-petugas-meja-pelayanan-pengelola-website',
        },
    ]

    useEffect(() => {
        const suffleArray = shuffleArray(MenuProfile);
        let filteredArray = [];
        for (let i = 0; i < suffleArray.length; i++) {
            if (i < 4) {
                filteredArray.push(suffleArray[i])
            }
        }
        setTagData(filteredArray);
    }, []);

    return (
        <div className="single_tag_share">
            <div className="tag-cat">
                <ul className="single_post_tag_layout">
                    {
                        TagData && TagData.map((item, index) => {
                            return (
                                <li key={index}>
                                    <Link to={item.link} rel={item.name}>{item.name}</Link>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </div>
    )
};